// Cashier Transactions State

export default {
  transactionsList: [],
  transactionInfo: {}
}
